import DocumentTitle from 'react-document-title';

import { useBreakpoint } from '@hivebrite/design-system/Theme';

import { newsAppHeader } from 'hb-react/frontoffice/apps/NewsIndex/blocks/newsAppHeader';
import { newsCategoryTags } from 'hb-react/frontoffice/apps/NewsIndex/blocks/newsCategoryTags';
import { newsPinnedItems } from 'hb-react/frontoffice/apps/NewsIndex/blocks/newsPinnedItems';
import { newsSearchFilters } from 'hb-react/frontoffice/apps/NewsIndex/blocks/newsSearchFilters';
import { newsSearchResults } from 'hb-react/frontoffice/apps/NewsIndex/blocks/newsSearchResults';
import { type Config } from 'hb-react/frontoffice/apps/NewsIndex/types';
import BlocksRenderer from 'hb-react/frontoffice/components/BlocksRenderer';
import oneColumnTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/OneColumnTemplate';
import twoColumnsTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/TwoColumnsTemplate';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import getNewsHeaderProps from 'hb-react/shared/apps/News/utils/getNewsHeaderProps';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';
import { usePageMenuName, PAGES } from 'hb-react/shared/hooks/usePageMenuName';
import { generatePageTitle } from 'hb-react/shared/utils/generatePageTitle';

export const NewsIndexContainer = ({
  config,
  topic,
}: {
  config: Config;
  topic?: any;
}) => {
  const { flagEvNewsRevamp } = useFeatureFlag();
  const { currentNetwork } = useDefaultAppContexts();
  const breakpoint = useBreakpoint();

  const { topicId, whitelabelName, topicName } = useTopicContext();

  const appHeaderProps = getNewsHeaderProps({
    appPageConfig: config?.custom?.page,
  });

  const TEMPLATES = {
    [oneColumnTemplate.id]: oneColumnTemplate,
    [twoColumnsTemplate.id]: twoColumnsTemplate,
  };

  const templateId =
    config?.custom?.page?.config?.blocks_renderer_template ||
    twoColumnsTemplate.id;

  const configPageName = config?.custom?.page?.menu_name;
  const appPagesMenuName = usePageMenuName(PAGES.NEWS, __('News'), {
    enabled: !configPageName,
  });

  // For PO try to get the name from the config.
  const menuName = configPageName || appPagesMenuName;

  const template = TEMPLATES[templateId];

  return (
    <>
      <DocumentTitle
        title={generatePageTitle({
          title: menuName || '',
          networkName: currentNetwork?.page_title || currentNetwork?.title,
          topicName: whitelabelName || topic?.name || topicName,
        })}
      />
      <BlocksRenderer
        blocks={[
          newsAppHeader({ appHeaderProps }),
          newsSearchFilters({ breakpoint, flagEvNewsRevamp }),
          newsPinnedItems({
            config,
          }),
          newsCategoryTags({ config }),
          newsSearchResults({
            breakpoint,
            config,
          }),
        ]}
        // @ts-expect-error - BlocksRenderer is not typed
        templateComponent={template.component}
        templateId={template.id}
        templateProps={{
          hasFilters: true,
          topicId,
        }}
        // @ts-expect-error - BlocksRenderer is not typed
        templateZones={template.zones}
      />
    </>
  );
};
